/**
 * 亲密空间
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message, Popover } from 'antd';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import './common.scss';
import * as Map from 'immutable';
import { DDLoading } from '../globalPageStatus';
import {
  _change_affinity_modal,
  _change_ds_modal,
} from '../../../src/store/Action';
import Util from '../../script/util';
import TokenSort from './TokenSort';
import LevelDress from './LevelDress';
import TokenDetailModal from './components/TokenDetailModal';
import IframeMiniModal from '../../components/iframModal/IframMiniModal';
import InterestAffinityDetailModal from './components/InterestAffinityDetailModal';

class AffinitySpace extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      searchUid: null,
      intimateRelationId: null,
      interestAffinityDetailVisible: false,
      interestAffinityDetail: null,
      detail: {},
    };
  }
  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.affinitySpaceModal);
    const props2 = Map.fromJS(this.props.base.affinitySpaceModal);

    if (!this.props.base.affinitySpaceModal) {
    } else if (this.props.base.affinitySpaceModal && !Map.is(props1, props2)) {
      const { searchUid, otherUid, intimateRelationId } =
        this.props.base.affinitySpaceData;
      this.setState(
        {
          searchUid,
          otherUid,
          intimateRelationId,
        },
        () => {
          this.getAffinitySpaceInfo();
        }
      );
    }
  }
  showModal = () => {
    this.getAffinitySpaceInfo();
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
    _change_affinity_modal({
      affinitySpaceModal: false,
      affinitySpaceData: {},
    });
  };

  //获取亲密空间信息
  getAffinitySpaceInfo = () => {
    const { searchUid, otherUid, intimateRelationId } = this.state;
    let params = {
      searchUid,
      otherUid,
      intimateRelationId,
    };
    HTTP._get_affinity_space_info(params).then((res) => {
      if (res.code == 200) {
        if (res.data && Object.keys(res.data).length > 0) {
          this.setState({ detail: res.data, visible: true });
        } else {
          message.warning('未找到亲密关系数据');
        }
      } else {
        message.error(res.message);
      }
    });
  };

  onSort = () => {
    const { detail } = this.state;
    this.tokenSortElement.showModal(detail);
  };

  onReload = () => {
    this.getAffinitySpaceInfo();
  };

  //打开等级装扮
  openLevelDress = () => {
    const { detail } = this.state;
    this.levelDressElement.showModal(detail);
  };
  //打开解除关系
  openDeleteAffinity = () => {
    const { detail } = this.state;
    _change_affinity_modal({
      affinityDeleteModal: true,
      affinityDeleteOtherUid: detail?.otherUid,
      affinityDeleteOrderNo: detail?.orderNo,
    });
    this.hideModal();
  };

  //打开信物详情
  openTokenDetail = (data) => {
    this.tokenDetailModalElement.showModal(data);
  };

  // 查看亲密关系规则
  openRuleModal = () => {
    const {
      base: { rootConfig },
    } = this.props;
    this.iframeMiniElement.showModal(
      `${rootConfig.mobilePath}/intimate-growth-rules/index.html`,
      {
        // this.iframeMiniElement.showModal(`${rootConfig.mobilePath}/intimate-affinity-rules/index.html`, {
        width: 375,
        height: 740,
        isBorderRadius: false,
      }
    );
  };

  //打开趣味关系详情
  openInterestAffinityDetail = (item) => {
    const { detail } = this.state;
    this.setState({
      interestAffinityDetailVisible: true,
      interestAffinityDetail: { ...detail, ...item },
    });
  };
  //关闭趣味关系详情
  closeInterestAffinityDetail = () => {
    this.setState({
      interestAffinityDetailVisible: false,
      interestAffinityDetail: null,
    });
  };

  jumpDsModal = (uid) => {
    _change_ds_modal({
      dsid: uid,
      origin: 'AffinitySpace',
    });
    this.hideModal();
  };

  render() {
    const {
      base: { userInfo },
    } = this.props;
    const {
      loading,
      detail,
      visible,
      interestAffinityDetailVisible,
      interestAffinityDetail,
    } = this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border affinity-space"
          style={{
            backgroundImage: `url(${Util.transImgUrl(detail?.relationConfig?.spaceBackground)})`,
          }}
          centered={true}
          title={`亲密空间`}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="512px"
          zIndex={1002}
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <Scrollbar
              ref={(el) => (this.scrollElement = el)}
              className="my-scroll-bar"
              style={{ height: '620px' }}
            >
              <div className="affinity-space-box">
                <Popover
                  rootClassName="daidai-popover-default gift-level-popover"
                  trigger="hover"
                  placement="bottom"
                  content={
                    <>
                      <span
                        className="sort-item-text"
                        onClick={this.openRuleModal}
                      >
                        规则说明
                      </span>
                      <span
                        className="sort-item-text"
                        onClick={this.openLevelDress}
                      >
                        等级装扮
                      </span>
                      {userInfo?.uid == detail?.searchUid ? (
                        <span
                          className="sort-item-text"
                          onClick={this.openDeleteAffinity}
                        >
                          解除关系
                        </span>
                      ) : null}
                    </>
                  }
                >
                  <div className="affinity-space-more">
                    <span>...</span>
                  </div>
                </Popover>
                <div className="affinity-space-top">
                  <div
                    className="affinity-space-item"
                    onClick={() => this.jumpDsModal(detail?.searchUid)}
                  >
                    <div className="affinity-space-avatar">
                      <img
                        src={Util.transImgUrl(detail?.searchAvatar, '100x100')}
                        alt=""
                      />
                    </div>
                    <div className="affinity-space-name">
                      {detail?.searchNickName}
                    </div>
                  </div>
                  <div
                    className={`affinity-space-line line-${detail?.relationConfig?.relationConfigId - 999}`}
                  ></div>
                  <div
                    className="affinity-space-item"
                    onClick={() => this.jumpDsModal(detail?.otherUid)}
                  >
                    <div className="affinity-space-avatar">
                      <img
                        src={Util.transImgUrl(detail?.otherAvatar, '100x100')}
                        alt=""
                      />
                    </div>
                    <div className="affinity-space-name">
                      {detail?.otherNickName}
                    </div>
                  </div>
                </div>
                <div className="affinity-space-text text-1">
                  <p>
                    成为
                    <span
                      style={{
                        color: detail?.relationConfig?.relationConfigCardStyle,
                      }}
                    >
                      {detail?.relationConfig?.relationConfigName}
                    </span>
                    已经<b>{detail?.daysBetween}</b>天
                  </p>
                </div>
                <div
                  className="affinity-space-card"
                  style={{
                    backgroundImage: `url(${Util.transImgUrl(detail?.relationConfig?.spaceSmallBackground)})`,
                  }}
                >
                  <div
                    className="affinity-space-card-level"
                    style={{
                      color: detail?.relationConfig?.relationConfigCardStyle,
                    }}
                  >
                    {detail?.relationConfig?.relationConfigName}LV
                    {detail?.level}
                  </div>
                  <div className="affinity-space-card-cover">
                    <img
                      src={Util.transImgUrl(
                        detail?.relationConfig?.spaceCardDecoration,
                        '50x50'
                      )}
                      alt=""
                    />
                  </div>

                  <div className="affinity-space-card-value">
                    亲密值
                    <span style={{ color: '#FFA818' }}>{detail?.intimate}</span>
                  </div>
                  {userInfo?.uid == detail?.searchUid ? (
                    <div className="affinity-space-card-progress">
                      <div
                        className="affinity-space-card-progress-bar"
                        style={{
                          width:
                            detail?.maxLevel == detail?.level
                              ? '100%'
                              : detail?.ratioIntimate + '%',
                          background:
                            detail?.relationConfig?.relationConfigCardStyle,
                        }}
                      ></div>
                    </div>
                  ) : null}
                  {userInfo?.uid == detail?.searchUid &&
                  detail?.maxLevel == detail?.level ? (
                    <div className="affinity-space-card-bottom">
                      <p style={{ flex: 1 }}>已达到满级</p>
                    </div>
                  ) : (
                    userInfo?.uid == detail?.searchUid && (
                      <div className="affinity-space-card-bottom">
                        <span
                          style={{
                            color:
                              detail?.relationConfig?.relationConfigCardStyle,
                          }}
                        >
                          Lv{detail?.level}
                        </span>
                        <p>
                          还需
                          <span style={{ color: '#fff' }}>
                            {detail?.betweenIntimate}
                          </span>
                          亲密值可升级
                        </p>
                        <span
                          style={{
                            color:
                              detail?.relationConfig?.relationConfigCardStyle,
                          }}
                        >
                          Lv{detail?.nextLevel}
                        </span>
                      </div>
                    )
                  )}
                </div>
                <div className="affinity-space-tip">
                  <p>信物墙</p>
                </div>
                <div className="affinity-space-token-wrap">
                  {userInfo?.uid == detail?.searchUid ? (
                    <div
                      className="affinity-space-token-sort"
                      onClick={this.onSort}
                    >
                      排序
                    </div>
                  ) : null}
                  <div
                    className="affinity-space-token-top"
                    onClick={() =>
                      this.openTokenDetail(detail?.keepsakeList?.[0])
                    }
                  >
                    {detail?.keepsakeList?.length > 0 ? (
                      <img
                        src={Util.transImgUrl(
                          detail?.keepsakeList[0]?.staticPic,
                          '120x120'
                        )}
                        alt=""
                      />
                    ) : null}
                  </div>
                  <div className="affinity-space-token-content">
                    {detail?.keepsakeList?.slice(1).map((item) => (
                      <div
                        className="affinity-space-token-cell"
                        key={item.giftId}
                        onClick={() => this.openTokenDetail(item)}
                      >
                        <img
                          src={Util.transImgUrl(item.staticPic, '120x120')}
                          alt=""
                        />
                      </div>
                    ))}
                  </div>
                  {/* <div className="affinity-space-token-bottom">
                    <p>展开所有</p>
                    <i className="icon-down"></i>
                  </div> */}
                </div>
                <div className="affinity-space-tip">
                  <p>趣味关系</p>
                </div>
                <div className="affinity-space-interest-wrap">
                  {detail?.funRelationList?.map((item) => (
                    <div
                      className={`affinity-space-interest-item ${item.lightType ? '' : 'lock'}`}
                      key={item.propConfigId}
                      onClick={() =>
                        item.lightType && this.openInterestAffinityDetail(item)
                      }
                    >
                      <img
                        src={Util.transImgUrl(item.lightedIcon, '218x308')}
                        alt=""
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Scrollbar>
          </DDLoading>
        </Modal>

        <TokenSort
          wrappedComponentRef={(el) => (this.tokenSortElement = el)}
          base={this.props.base}
          onReload={this.onReload}
        />
        <LevelDress
          wrappedComponentRef={(el) => (this.levelDressElement = el)}
          base={this.props.base}
        />
        <TokenDetailModal
          wrappedComponentRef={(el) => (this.tokenDetailModalElement = el)}
          base={this.props.base}
        />
        {/* H5弹窗 */}
        <IframeMiniModal
          wrappedComponentRef={(el) => (this.iframeMiniElement = el)}
        />
        {/* 趣味关系详情 */}
        <InterestAffinityDetailModal
          visible={interestAffinityDetailVisible}
          data={interestAffinityDetail}
          onClose={this.closeInterestAffinityDetail}
        />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(AffinitySpace, { withRef: true })
);
